interface UnitToggleProps {
  isImperial: boolean;
  onToggle: (imperial: boolean) => void;
  metricLabel: string;
  imperialLabel: string;
}

const UnitToggle = ({ isImperial, onToggle, metricLabel, imperialLabel }: UnitToggleProps) => (
  <div className="unit-toggle">
    <span className={`unit-toggle-slider ${isImperial ? "unit-toggle-slider--right" : ""}`} />
    <button
      type="button"
      className={`unit-toggle-btn ${!isImperial ? "unit-toggle-btn--active" : ""}`}
      onClick={() => onToggle(false)}
    >
      {metricLabel}
    </button>
    <button
      type="button"
      className={`unit-toggle-btn ${isImperial ? "unit-toggle-btn--active" : ""}`}
      onClick={() => onToggle(true)}
    >
      {imperialLabel}
    </button>
  </div>
);

export default UnitToggle;
